export class ScorecardItem {
    constructor(
        public title: string,
        public value: string,
        public iconClass: string
    ) { }
}
